<template>
  <component v-if="data" :is="themeName" :key="uuidValue" :data="data" />
</template>

<script>
import capitalize from 'lodash/capitalize'
import GuestDocumentationMixin from '@/mixins/guestdocumentation'
import { uuid } from '@/helpers'

export default {
  name: 'GuestDocumentationHome',
  metaInfo () {
    const link = document.querySelector("link[rel*='icon']")
    link.href = this.metadata.href
    return {
      title: `Guest Documentation | ${capitalize(this.metadata.image)}`,
      meta: [
        { name: 'description', content: 'Your Trip Documentation -Including the Itinerary, Hotel List & Optional Excursions (if apply)' },
        { property: 'og:title', content: this.metadata.title },
        { property: 'og:site_name', content: 'Guest Documentation' },
        { property: 'og:image', content: this.metadata.image },
        { property: 'og:url', content: this.metadata.url }
      ]
    }
  },
  mixins: [ GuestDocumentationMixin ],
  computed: {
    uuidValue () {
      return uuid()
    },
    metadata () {
      if (this.data) {
        return {
          title: this.data.data.opportunity_name,
          description: this.data.data.reference_number,
          image: this.data.template,
          url: this.data.hash,
          href: `/guestdocumentation/${this.data.template}/img/favicon.ico`
        }
      }
      return 'empty'
    },
    themeName () {
      if (this.data) {
        const prefix = 'GuestDocumentation'
        const templateName = capitalize(this.data.template)
        if (templateName) {
          return `${prefix}${templateName}`
        }
        return `${prefix}Default`
        // return 'WebLinkInsightVacations'
      }
      return {}
    }
  }
}
</script>
